const menu = {
    label: 'Acordo de Parcerias',
    icon: 'pi pi-fw pi-slack',
    to: '/mapaparceiros/parceria',
    rules: ['MAPAPARC-PAR-00'],
};

export default menu;
